<template>
  <el-scrollbar style="height:90%">
    <eco-tree
      :data="treeData"
      :props="defaultProps"
      :support-filter="supportFilter"
      :highlight-current="highlightCurrent"
      :default-expand-all="defaultExpandAll"
      :default-expanded-keys="_defaultExpandedKeys"
      node-key="id"
      :show-checkbox="showCheckbox"
      :render-content="renderContent"
      :expand-on-click-node="false"
      @refresh="handleRefresh"
      @node-click="handleNodeClick"
      @check="check"
      ref="ecoTree"
    >
      <!-- 作用域插槽：插槽prop -->
      <slot slot-scope="{ node, data }" :node="node" :data="data"></slot>
    </eco-tree>
  </el-scrollbar>
</template>

<script>
import sysType from "@/api/sysType.js";
import helendesign from "@/api/helendesign.js";
import managePlan from "@/api/managePlan.js";
/**
 * catId  typeKey
 * 1	REPORT_TYPE	报表分类
 * 10	USER_REL_TYPE	用户关系分类
 * 11	WORK_ITEM_TYPE	工作台分类
 * 12	REPORT_LINE	汇报线分类
 * 2	INDEX_COLUMN_TYPE	首页栏目分类
 * 3	DEMENSION_TYPE	组分类
 * 4	MAIL_TYPE	邮件分类
 * 5	DIC	数据字典
 * 6	FLOW_TYPE	流程分类
 * 7	FORM_TYPE	表单分类
 * 8	ENT_TYPE	业务实例
 * 9	DEF_TYPE	业务定义
 *
 */
export default {
  name: "fe-sys-type-tree",
  props: {
    catId: {
      type: String | Number,
      default: ""
    },
    typeKey: {
      type: String | Number,
      default: ""
    },
    costKey: {
      type: Boolean,
      default: false
    },
    buildKey: {
      type: Boolean,
      default: false
    },
    managePlanKey: {
      type: String,
      default: ''
    },
    supportFilter: {
      type: Boolean,
      default: false
    },
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    defaultExpandedKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    renderContent: {
      type: Function
    },
    tabIndex: {
      type: String,
      default: () => "first"
    },
    activeName: {
      type: String,
      default: () => "first"
    }
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      _defaultExpandedKeys: []
    };
  },
  watch: {
    defaultExpandedKeys: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this._defaultExpandedKeys = newVal;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleNodeClick(node,data) {
      this.$emit("node-click", node,data);
    },
    check(data, checkedObj) {
      this.$emit("check", data, checkedObj);
    },
    loadData(cb) {
      if (this.catId) {
        sysType.getSysTypeByCatId(this.catId).then(data => {
          this.treeData = data;
          cb && cb();
        });
      }
      if (this.typeKey) {
        sysType.getTypesByKey(this.typeKey).then(data => {
          this.treeData = data;
          cb && cb();
        });
      }
      if (this.costKey) {
        if (this.activeName === "first") {
          let params = {
            pageBean: {
              page: 1,
              pageSize: 10,
              showTotal: true
            }
          };
          sysType.getCostAccountTemplate(params).then(data => {
            this.treeData = data;
            cb && cb();
          });
        }
        if (this.activeName === "second") {
          let params = {
            pageBean: {
              page: 1,
              pageSize: 10,
              showTotal: true
            }
          };
          sysType.getDefaultCostAccountTemplate(params).then(data => {
            this.treeData = data;
            cb && cb();
          });
        }
      }
      if (this.buildKey) { 
        if (this.tabIndex === "first") {
          helendesign.getMyProcessTemplate().then(data => {
            this.treeData = data.value;
            cb && cb();
          });
        }
        if (this.tabIndex === "second") {
          helendesign.getProcessTemplate().then(data => {
            this.treeData = data.value;
            cb && cb();
          });
        }
      }
      if (this.managePlanKey) { 
        if (this.tabIndex === "first") {
          managePlan.getMySelfTemplate('',this.managePlanKey).then(data => {
            this.treeData = data.value;
            cb && cb();
          });
        }
        if (this.tabIndex === "second") {
          managePlan.getPublicTemplate('',this.managePlanKey).then(data => {
            this.treeData = data.value;
            cb && cb();
          });
        }
      }
    },
    handleRefresh(cb) {
      this.loadData(cb);
    }
  },
  mounted() {
    this._defaultExpandedKeys = [this.catId];
    this.loadData();
  }
};
</script>
<style lang="scss" scoped>
>>> .el-tree .el-tree__empty-block {
  margin: 20px 20px;
}

>>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
